import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import ColorSF2 from '../../styles/common/ColorSF2';

const MainBlock = styled.div`
  height: 50px;
  flex: 0 0 auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background-color: ${ColorSF2.paleBlue};
  padding: 0 10px;
  @media (max-height: 530px) {
    height: 30px;
  }
`;

const ContentsBlock = styled.div`
  height: '100%';
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const ContentsTitle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-weight: bold;
`;

/**
 * デバイス管理ページのヘッダーコンポーネント
 * @returns {ReactElement}
 */
const DeviceTitle = () => (
  <MainBlock className="deviceTitle">
    <ContentsBlock>
      <ContentsTitle>
        <FormattedMessage id="device.title" />
      </ContentsTitle>
    </ContentsBlock>
  </MainBlock>
);

export default DeviceTitle;
